import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL + 'v1/locations';

class driverLocationService {

    createLocation(location) {
        return axios.post(API_URL, location);
    }

    getRouteForOrder(orderId) {
        return axios.get(`${API_URL}/route/${orderId}`);
    }

    getLatestLocationsForAvailableDrivers() {
        return axios.get(`${API_URL}/active-drivers`);
    }

    async getClosestDriverLocation(orderId, droppedOffTime) {
        const response = await axios.get(`${API_URL}/${orderId}/closest`, {
            params: { droppedOffTime }
        });
        return response;
    }
}


export default new driverLocationService();
